import React from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import PlusIcon from 'assets/icons/icon-plus-box-outline.svg?react';
import MinusIcon from 'assets/icons/icon-minus-box-outline.svg?react';
import professionCases from 'helpers/professionCases';

const WrapperLeft = styled('div')(({ theme, slides }) => ({
  flex: slides === 'true' ? 0 : 1,
  borderRadius: 15,
  backgroundColor: theme.palette.white.main,
  border: `2px solid ${theme.palette.primary.main}`,
  [theme.breakpoints.down('md')]: {
    marginBottom: 20
  }
}));

const WrapperRight = styled('div')(({ slides, theme }) => ({
  flex: slides === 'true' ? 0 : 1,
  borderRadius: 15,
  backgroundColor: theme.palette.white.main,
  border: `2px solid ${theme.palette.error.main}`
}));

const Title = styled(Typography)(({ theme }) => ({
  fontSize: 24,
  padding: '11px 25px 10px',
  borderBottom: `1px solid ${theme.palette.textDisabled.main}`,
  [theme.breakpoints.down('md')]: {
    lineHeight: '34px'
  }
}));

const ItemsWrapper = styled('div')(() => ({
  padding: '16px 25px'
}));

const ItemWrapper = styled('div')(() => ({
  paddingLeft: 45,
  position: 'relative',
  marginBottom: 30,
  '& svg': {
    position: 'absolute',
    left: 0,
    top: 0
  }
}));

const BenefitTitle = styled(Typography)(() => ({
  fontSize: 18,
  marginBottom: 5,
  lineHeight: 'normal'
}));

const BenefitDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[400],
  fontSize: 16
}));

const PlusIconStyled = styled(PlusIcon)(() => ({}));

const MinusIconStyled = styled(MinusIcon)(() => ({}));

const BenefitsComponent = ({ professionInfo, t, slides }) => {
  const advantages = professionInfo?.advantages || [];
  const disadvantages = professionInfo?.disadvantages || [];

  // Hide component if both advantages and disadvantages are empty
  if (!advantages.length && !disadvantages.length) {
    return null;
  }

  return (
    <>
      {advantages.length > 0 && (
        <WrapperLeft slides={`${slides}`}>
          <Title variant={'h2'}>{t('Benefits', professionCases(professionInfo, 'genitive'))}</Title>
          <ItemsWrapper>
            {advantages.map((benefit) => (
              <ItemWrapper key={benefit._id}>
                <PlusIconStyled />
                <BenefitTitle variant="h3">{benefit.name}</BenefitTitle>
                <BenefitDescription variant="body1">{benefit.description}</BenefitDescription>
              </ItemWrapper>
            ))}
          </ItemsWrapper>
        </WrapperLeft>
      )}
      {disadvantages.length > 0 && (
        <WrapperRight slides={`${slides}`}>
          <Title variant={'h2'}>
            {t('Disadvantages', professionCases(professionInfo, 'genitive'))}
          </Title>
          <ItemsWrapper>
            {disadvantages.map((disadvantage) => (
              <ItemWrapper key={disadvantage?._id}>
                <MinusIconStyled />
                <BenefitTitle variant="h3">{disadvantage.name}</BenefitTitle>
                <BenefitDescription variant="body1">{disadvantage.description}</BenefitDescription>
              </ItemWrapper>
            ))}
          </ItemsWrapper>
        </WrapperRight>
      )}
    </>
  );
};

export default BenefitsComponent;
